export default function PageHeader({ eyebrow, title, subtitle, image, testId }) {
  return (
    <section
      className="relative pt-40 pb-20 bg-[#0A1F3F] text-white overflow-hidden"
      data-testid={testId || "page-header"}
    >
      {image && (
        <>
          <img
            src={image}
            alt=""
            className="absolute inset-0 w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0A1F3F]/95 via-[#0A1F3F]/75 to-[#0A1F3F]/40" />
        </>
      )}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="max-w-3xl">
          {eyebrow && (
            <div className="flex items-center gap-3 mb-5">
              <span className="w-10 h-px bg-[#F37021]" />
              <span className="text-eyebrow text-[#F37021]">{eyebrow}</span>
            </div>
          )}
          <h1 className="font-display font-black uppercase tracking-tighter text-5xl sm:text-6xl lg:text-7xl leading-[0.95]">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 text-base sm:text-lg text-white/80 max-w-2xl leading-relaxed">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
